import classes from './Color.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode
  display?: 'inline' | 'inline-flex'
  variant: 'purple' |
  'lightPurple' |
  'darkPurple' |
  'blue' |
  'lightblue' |
  'darkBlue' |
  'teal' |
  'red' |
  'redHover' |
  'highlightred' |
  'orange' |
  'violet' |
  'green' |
  'secondarygreen' |
  'black' |
  'gray' |
  'greyA' |
  'greyB' |
  'greyC' |
  'lightGray' |
  'stateGray' |
  'greyDivider' |
  'theme-filter-icon' |
  'theme-delete-danger' |
  'theme-color-statuschip-text' |
  'theme-color-id' |
  'theme-placeholder-text' |
  'theme-description-text' |
  'theme-drag-and-drop-box-icon-color' |
  'theme-color-tab-label-unselected' |
  'theme-color-checkbox-border' |
  'theme-progress-flow-text'|
  'form-alert-text-color'|
  'theme-color-readonly-field-text' |
  'theme-color-checkbox-border' |
  'theme-color-links' |
  'theme-color-dnd-icon' |
  'theme-progress-flow-background-color' |
  'theme-color-text' |
  'theme-test-case-global-icon-color' |
  'theme-remove-chip' |
  'theme-color-light-text'
}

const Color = ({
  children,
  display = 'inline-flex',
  variant
}: Props) =>
  <span className={classes.Color + ' ' + classes[variant] + ' ' + classes[display]}>
    {children}
  </span>

export default Color
